module.exports = __webpack_public_path__ + "assets/img/7.bf3e76f8.jpg";